<template>
  <svg
    class="chat-msg-icon-bubble"
    viewBox="0 0 53 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <circle cx="26.1113" cy="26.9688" r="26" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1113 24.9021C12.1113 18.3021 18.378 12.9688 26.1113 12.9688C33.8447 12.9688 40.1113 18.3021 40.1113 24.9021C40.1113 31.4354 33.9113 36.7688 26.2447 36.8354C25.0579 38.6815 21.1978 40.4624 20.2744 40.8883L20.2447 40.9021C20.178 40.9688 20.0447 40.9688 19.978 40.9688C19.778 40.9688 19.6447 40.9021 19.5113 40.7688C19.378 40.5688 19.3113 40.3021 19.378 40.0354C19.9113 38.6354 20.4447 36.9021 20.5113 36.2354C19.178 35.5021 12.1113 31.3021 12.1113 24.9021ZM17.6219 22.6257C17.6219 21.9813 18.1443 21.459 18.7886 21.459H33.5664C34.2107 21.459 34.7331 21.9813 34.7331 22.6257C34.7331 23.27 34.2107 23.7923 33.5664 23.7923H18.7886C18.1443 23.7923 17.6219 23.27 17.6219 22.6257ZM20.3318 26.2185C19.6875 26.2185 19.1652 26.7408 19.1652 27.3852C19.1652 28.0295 19.6875 28.5518 20.3318 28.5518H31.9985C32.6428 28.5518 33.1652 28.0295 33.1652 27.3852C33.1652 26.7408 32.6428 26.2185 31.9985 26.2185H20.3318Z"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class BubbleIcon extends Vue {}
</script>

<style lang="scss">
@import '@/assets/scss/base.scss';

svg.chat-msg-icon-bubble {
  circle {
    fill: $chat-bubble-background;
  }
  path {
    fill: $chat-bubble-text-color;
  }
}
</style>
